import React, {useMemo} from 'react';
import {QuestionModelV3} from 'resources/augmented/Question/QuestionModel.v3';
import {useShallow} from 'zustand/react/shallow';

import {useQuestionTranslationStore} from '../../shared/TranslationSection';
import MarkdownBlock from '../../shared/MarkdownBlock/MarkdownBlock';

import TextHighlightPrompt from './TextHighlightPrompt.react';

interface TextHighlightExplanationProps {
  storeName?: string;
  question?: QuestionModelV3;
  activeQuestionStore?: any;
}

const TextHighlightExplanation = ({
  storeName,
  question,
  activeQuestionStore
}: TextHighlightExplanationProps) => {
  const {translatedQuestionInfo, showTranslations} = useQuestionTranslationStore(
    useShallow((state) => ({
      translatedQuestionInfo: state.translatedQuestionInfo,
      showTranslations: state.showTranslations && state.translationSettings.question
    }))
  );
  const sample: string = useMemo(() => {
    if (showTranslations) {
      return translatedQuestionInfo?.sample;
    }
    return question.getMeta().getSample();
  }, [question, showTranslations, translatedQuestionInfo]);

  return (
    <div>
      <div className='text-highlight-explanation'>
        <h2>Correct Selections</h2>
        <TextHighlightPrompt
          explanation
          storeName={storeName}
          question={question}
          isGuessSubmitted
          activeQuestionStore={activeQuestionStore}
        />
      </div>
      {sample && <MarkdownBlock heading='Sample Response' text={sample} />}
    </div>
  );
};

export default TextHighlightExplanation;
